<template>
    <a class="add-to-cart" rel="nofollow" @click.prevent="addToCart">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <g id="Assets_Icons_24_Cart" data-name="Assets/Icons/24/Cart" transform="translate(-2 -2)">
                <path id="Icon" d="M15.5,20A1.5,1.5,0,1,1,17,18.5,1.5,1.5,0,0,1,15.5,20Zm-9,0A1.5,1.5,0,1,1,8,18.5,1.5,1.5,0,0,1,6.5,20Zm8.9-5H6.716A3.015,3.015,0,0,1,3.783,12.63l-.032-.174L2.142,2H1A1,1,0,0,1,.884.006L1,0H3a1,1,0,0,1,.966.738l.023.11L4.473,4H19a.987.987,0,0,1,.742.329A1,1,0,0,1,20,5.1l-.019.117L18.324,12.65a3.014,3.014,0,0,1-2.746,2.344L15.4,15ZM4.781,6l.947,6.152a1,1,0,0,0,.876.841L6.716,13H15.4a1,1,0,0,0,.945-.671l.031-.112L17.753,6Z" transform="translate(2 2)"/>
            </g>
        </svg>
    </a>
</template>

<script>
import {inject, onMounted, reactive, ref, toRefs} from 'vue'
import axios from 'axios';
import {isJson} from "../../../functions";
import emitter from '../../utils/emitter';

export default {
    props: {
        route: {required: true},
        productId: {required: true},
        gtmDataP: null
    },

    setup(props) {
        const quantity = ref(1)
        const state = reactive({
            gtmData: null,
        })

        const emitter2 = inject('emitter')

        onMounted(() => {
            emitter.on('updateQuantity', data => {
                quantity.value = data.value
                state.gtmData.items[0].quantity = data.value
            })

            if ( isJson(props.gtmDataP) ) {
                state.gtmData = JSON.parse(props.gtmDataP)
            } else {
                state.gtmData = props.gtmDataP
            }
        })

        function addToCart() {
            axios.post(`/kosik/pridat-do-kosika/${props.productId}`, {
                id: props.productId,
                quantity: typeof quantity.value !== 'undefined' ? quantity.value : 1,
                type: 'product'
            }).then(response => {
                emitEvent(response)
                if(response.data.error && response.data.popup){
                    let htmlObject = document.createElement('div');
                    htmlObject.innerHTML = response.data.popup;
                    document.body.appendChild(htmlObject);
                }
                else{
                    emitter.emit('productAdded', response.data);
                    emitter.emit('updateBasket', response.data.quantity)
                }
            }).catch(error => {
                console.log(error)
                emitEvent()
            })
        }

        const emitEvent = () => {
            emitter2.emit('track-event', {
                data: state.gtmData,
                event: 'addToCart'
            })
        }

        return {
            ...toRefs(state),
            addToCart
        }
    }
}
</script>
